// Use to show all nodes, parents, and children

import React from 'react'
import { Table, Col, Card, CardHeader, CardBody, Badge } from 'reactstrap'
import arrayify from '../../../helpers/arrayify'
import { Link } from 'react-router-dom'
import ParentChildAdder from './ParentChildAdder'
import NodeSearchBar from './NodeSearchBar'

// props: rowsData, listName

export default function NodeList (props) {
  let nodeRows = <tr></tr>
  if (props.rowsData) {
    const rowsDataArray = arrayify(props.rowsData)
    if (props.selector) {
      nodeRows = rowsDataArray.map((row, n) => {
        return (
            <tr 
              key={'nodeRow' + props.listName + n} 
              className={row.id === props.activeNodeId ? 'bg-info m2selected-node' : null}
            >
              <td><Link to={`/content/knowledge-map/${row.id}`}>{row.name}</Link></td>
            </tr>
        )
      })
    } else {
      nodeRows = rowsDataArray.map((row, n) => {
        return (
          <tr key={'nodeRow' + props.listName + n}>
            <td>
              <Badge 
                className='m2clickable' 
                color='danger' 
                onClick={() => props.removeParentChild(props.listName === 'Parents', row.id)}
              >
                X
              </Badge>
              {' '}<Link className='m2-not-link-color' to={`/content/knowledge-map/${row.id}`}>{row.name}</Link>
            </td>
          </tr>
        )
      })
    }
  }

  let parentChildAdder = null

  if (!props.selector) {
    let parentOrChild
    if (props.listName === 'Parents') {
      parentOrChild = 'Parent'
    } else if (props.listName === 'Children') {
      parentOrChild = 'Child'
    }

    parentChildAdder = (
      <ParentChildAdder
        parentOrChild={parentOrChild}
        nodesAvail={props.nodesAvail}
        saveParentChild={props.saveParentChild}
        selectedNodeId={props.selectedNodeId}
        handleChange={props.handleChange}
      />
    )
  }

  let searchBar = null
  if (props.selector) {
    searchBar = <NodeSearchBar handleChange={props.handleChange} search={props.search}/>
  }

  return (
    <Col xs={props.xs} lg={props.lg}>
      <Card>
        <CardHeader>
          {props.listName}
        </CardHeader>
        <CardBody>
          {searchBar}
          <Table responsive size='sm'>
            <thead>
              <tr>
                <th>
                  Name
                </th>
              </tr>
            </thead>
            <tbody>
              {nodeRows}
            </tbody>
          </Table>
          {parentChildAdder}
        </CardBody>
      </Card>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/KnowledgeMap/NodeList.js